import { useState, useEffect } from 'react'

// Lightweight SPA path subscription for the v2 surface.
// Reads window.location.pathname, then re-renders subscribers when either
// the browser fires `popstate` (back/forward) or we fire the custom `v2-nav`
// event after a programmatic pushState.
//
// We avoid pulling in react-router because Atlas's v1 surface still uses
// a different routing model (hash + custom v1 state) and a global router
// would force a coordinated migration we are not ready for.

const NAV_EVENT = 'v2-nav'

function currentPath() {
  if (typeof window === 'undefined') return '/'
  return window.location.pathname
}

export function useV2Path() {
  const [path, setPath] = useState(currentPath)
  useEffect(() => {
    const onChange = () => setPath(currentPath())
    window.addEventListener('popstate', onChange)
    window.addEventListener(NAV_EVENT, onChange)
    return () => {
      window.removeEventListener('popstate', onChange)
      window.removeEventListener(NAV_EVENT, onChange)
    }
  }, [])
  return path
}

// Programmatic in-app navigation. No full reload. Updates the address bar
// and notifies every useV2Path subscriber.
export function v2Navigate(href) {
  if (typeof window === 'undefined' || !href) return
  if (window.location.pathname === href) return
  window.history.pushState({}, '', href)
  window.dispatchEvent(new Event(NAV_EVENT))
}
